import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {
    Form,
    Modal,
    Input,
    Radio,
    Checkbox,
} from 'antd';
import {connect} from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');
import {dateConversion} from '../../../utils';
import {getHostList, addWorkList, createAddWorkListStatusAction} from './actions';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;
const {TextArea} = Input;

let dataArray = [];
let user = JSON.parse(localStorage.getItem('HippoUserInfo'));
let today = dateConversion(Date.parse(new Date()));
let listData = [];

class AddWorkList extends Component {
    constructor(props) {
        super(props); // 调用super父类构造函数改变this指向
        this.state = {
            confirmLoading: false
        };

    }

    componentDidMount() {
    }


    // async handleInterstChange(value) {
    //   console.log('aaaa',value);
    // };
    //
    // async handleUserInfoChange(value) {
    //
    // };

    changeAddWorkHide = () => {
        //this.props.changeAddListStatus(false);
        this.props.changeAddWorkListStatus(false);
        this.props.form.resetFields();
    };

    async submit(i) {
        this.props.form.validateFields(async (err, fieldsValue) => {
            if (!err) {
                try {
                    this.setState({confirmLoading: true});
                    await this.props.addWorkList(fieldsValue.num)
                    await this.props.form.resetFields();
                    await this.changeAddWorkHide();//隐藏弹窗
                    await this.props.GetHostList();//刷新列表
                    this.setState({confirmLoading: false});
                } catch (err) {
                    console.log(err);
                    this.setState({confirmLoading: false});
                    alert(err);
                }
            } else {
                this.setState({confirmLoading: false});
                console.log(err);
            }
        });
    };

    render() {
        const {getFieldDecorator, onPanelChange} = this.props.form;
        const {status} = this.props;
        const formItemLayout = {
            labelCol: {
                xs: {span: 18},
                sm: {span: 6},
            },
            wrapperCol: {
                xs: {span: 18},
                sm: {span: 14},
            },
        };
        return (
            <div>
                <Modal
                    title={'创建worker机器'}
                    visible={status == true}
                    confirmLoading={this.state.confirmLoading}
                    onCancel={() => this.changeAddWorkHide()}
                    onOk={() => {
                        this.submit();
                    }}>
                    <Form>
                        <FormItem {...formItemLayout} label="创建机器数量">
                            {getFieldDecorator('num', {})(<Input placeholder="单次不可超100"/>)}
                        </FormItem>
                    </Form>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    status: state.hostList.addWorkListStatus //hostList为reducers.js中的变量名
});

const mapDispatchToProps = dispatch => ({
    GetHostList: prarms => dispatch(getHostList()),
    addWorkList: prarms => dispatch(addWorkList(prarms)),
    changeAddWorkListStatus: status => dispatch(createAddWorkListStatusAction(status)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(AddWorkList));



// WEBPACK FOOTER //
// ./pages/assist/hostManage/addWorkList.js